import { Drawer } from 'antd';
import styled from 'styled-components';

export const StyledDrawer = styled(Drawer)`
  .image-tags-drawer-content {
    padding: 0;
    padding: ${({ theme: { token } }) => token.marginMD}px ${({ theme: { token } }) => token.marginSM}px
      ${({ theme: { token } }) => token.marginSM}px ${({ theme: { token } }) => token.marginSM}px;
    background-color: ${({ theme: { token } }) => token.colorBgElevated};
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: ${({ theme: { token } }) => token.marginSM}px;

    .image-tags-drawer-title {
      color: ${({ theme: { token } }) => token.colorText};
      font-size: ${({ theme: { token } }) => token.fontSizeHeading3}px;
      font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
      line-height: ${({ theme: { token } }) => token.lineHeightLG};
    }

    .image-tags-list {
      flex-grow: 1;
      overflow-y: auto;
    }

    .image-tags-drawer-close-btn {
      margin: 0 ${({ theme: { token }}) => token.marginXS}px;
    }
  }
`;
